import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ashby = defineConnector({
  identifier: "ashby",
  name: "Ashby",
  tagLine: "All-in-one recruiting and ATS",
  logo,
  protocol: "http",
  tags: ["featured"],
  defaultUrlPattern: () => "https://api\\.ashbyhq\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: "",
    }),
  steps: [
    {
      title: "Create an Ashby API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to Ashby and navigate to **Admin > Integrations > API keys**. Click **Create API key** and give it a descriptive name. You’ll need the ‘Super Admin’ role to access this page.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "username" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.ashbyhq.com/apiKey.info",
  },
});
